import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { set } from 'lodash';

import feedviewsActions from '../../../redux/feedviews/actions';
import { Input } from '../../GlobalUI';

function Inventory({ fetching, feedviews, actions, group, onSubmit }) {
  const { id: groupId } = group;

  const [feedViewDefault, setFeedViewDefault] = useState({
    value: '',
    label: '',
  });

  const [feedViewHash, setFeedViewHash] = useState({});

  useEffect(() => {
    actions.feedviewsRequest();
  }, [actions]);

  useEffect(() => {
    const { onlineFeedview_id: onlineFeedviewId } = group?.config || {};
    if (onlineFeedviewId) {
      const onlineFeedView = feedViewHash[onlineFeedviewId] || '';
      setFeedViewDefault({
        value: onlineFeedviewId,
        label: onlineFeedView,
      });
    }
  }, [group, feedViewHash]);

  const feedviewsMap = useMemo(() => {
    const feedHash = {};
    const feedArray = feedviews.map(({ id, name }) => {
      feedHash[id] = name || id;
      return {
        value: id,
        label: name || id,
      };
    });
    setFeedViewHash(feedHash);
    return [{ value: null, label: '' }, ...feedArray];
  }, [feedviews]);

  const handleSubmit = (e, goNext) => {
    e.preventDefault();
    const nextRoute = `/group/${groupId}/setup/3`;
    const route = goNext ? nextRoute : null;
    const modifiedGroup = { ...group, route };
    set(
      modifiedGroup,
      'config.onlineFeedview_id',
      feedViewDefault?.value || null,
    );
    onSubmit({
      ...modifiedGroup,
    });
  };

  const onChangeSelectedFeedViewId = (e) => {
    setFeedViewDefault(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input
        type="select"
        label="Default online feed view"
        options={feedviewsMap}
        onChange={onChangeSelectedFeedViewId}
        value={feedViewDefault}
      />
      <div className="setup-spacer" />
      <ButtonGroup>
        <Button
          bsClass="btn btn-primary btn-large"
          disabled={fetching}
          type="submit"
        >
          Save and Exit
        </Button>
        <Button
          bsClass="btn btn-primary btn-large"
          disabled={fetching}
          type="button"
          onClick={(e) => handleSubmit(e, true)}
        >
          Save {`>>`}
        </Button>
      </ButtonGroup>
    </form>
  );
}

Inventory.propTypes = {
  feedviews: PropTypes.array,
  actions: PropTypes.object,
  fetching: PropTypes.bool,
  group: PropTypes.object,
  onSubmit: PropTypes.func,
};

const mapStateToProps = ({ feedviews }) => ({
  feedviews: feedviews?.feedviews,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedviewsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
